/**
 * Compare attributes of objects
 * @param obj1
 * @param obj2
 * @returns {boolean} if objects is equal
 */
export const compareObjects = (obj1, obj2) => {
    if (!obj1 || Object.keys(obj1).length === 0 || !obj2 || Object.keys(obj2).length === 0) {
        return false;
    }
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    return keys1.length === keys2.length && keys1.every(key => keys2.includes(key));
}
